import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type DepartmentDetails } from '../../types';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DepartmentService {
  private readonly http = inject(HttpClient);

  load(id: string): Observable<DepartmentDetails> {
    return this.http.get<DepartmentDetails>(`api/v1/tickets/department-details/${id}`);
  }
}
